<template>
  <artmisads-modal
    :open.sync="visible"
    :title="$t('seller.sellerAccount.modalSubmitTitle')"
    width="870px"
    @cancel="handleClose"
  >
    <div class="content">
      <div class="content-top">
       <svg-icon name="info-tianchong" class="icon" />
          <div class="text-style">
            {{ $t('seller.sellerAccount.modalInviteConfirm') }}
          </div>
      </div>
      <div class="content-mid">
        {{ $t('seller.sellerAccount.modalGuideHint') }}
      </div>
       <div class="guideContainerModal" @click.prevent="clickGuide">
      <div class="guideContainerModalLeft">
  
        <a-image
        class="wenhaoStyle"
        :src="require('@/assets/images/img/wenhao.png')"
        :alt="$t('seller.sellerAccount.guideAlt')"
      />
      <span class="guideText">{{ $t('seller.sellerAccount.guideLinkText') }}</span>
            
      </div> 
      <svg-icon name="jiantou-hengxian-you-cu" class="icon-jiantou" />
    </div>
    </div>
     <template #footer>
      <div>
        <artmisads-button  @click="handleClose">{{ $t('seller.common.cancel') }}</artmisads-button>
        <artmisads-button type="primary" @click="submit">{{ $t('seller.sellerAccount.modalSubmitButton') }}</artmisads-button>
      </div>
     </template>
  </artmisads-modal>
</template>
<script lang="jsx" setup>
import { ref ,defineExpose,defineEmits} from 'vue'
import SvgIcon from '~/components/SvgIcon.vue';
const emit = defineEmits(['submit','clickGuide'])
const visible = ref(false)
const show = (info) => {
  visible.value = true
}
const handleClose=()=>{
  visible.value = false
}
const submit=()=>{
  visible.value = false
  emit('submit')
}
const clickGuide=()=>{
  visible.value = false
  emit('clickGuide')
}
defineExpose({
  show
})

</script>
<style lang="less">
 .content{
   .guideContainerModal {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 10px;
  justify-content: space-between;
  background: #fff5e4;
  padding: 8px 16px;
  border: 1px solid #ff9619;
  border-radius: 6px;
  .guideContainerModalLeft{
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .icon-jiantou{
    font-size: 24px;
    color: #FF9619;
  }
  .wenhaoStyle {
    width: 26px !important;
    height: 26px !important;
  }

  .guideText {
   color: #0f0629b3;
 font-family: "Sora";
 font-size: 14px;
 font-style: normal;
 font-weight: 500;

 letter-spacing: 0.4px;
  }
}
  .content-top{
    display: flex;
    
  gap: 10px;

    border-radius: var(--Radius-Radius-8, 8px);
background: #50408014;
padding: 18px 10px;

   .icon{
  font-size: 24px;
    color: #835CF2;

   }
   .text-style{
     color: #0f0629;
 font-family: "Sora";
 font-size: 13px;
 font-style: normal;
 font-weight: 400;

 letter-spacing: 0.3px;
   }
  }
  .content-mid{
 color: #0f0629;
 font-family: "Sora";
 font-size: 13px;
 font-style: normal;
 font-weight: 400;
margin-top: 24px;
margin-bottom: 10px;
 letter-spacing: 0.3px;
  }
 } 

</style>
